import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { PortalUserInfo } from 'src/app/feature-module/portal-users/models/PortalUserInfo';
import { PortalUserService } from 'src/app/feature-module/portal-users/services/portalUser.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { UserSelectDialogComponent } from '../user-select-dialog/user-select-dialog.component';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';

@Component({
  selector: 'app-linked-portal-users',
  templateUrl: './linked-portal-users.component.html',
  styleUrls: ['./linked-portal-users.component.scss']
})
export class LinkedPortalUsersComponent implements OnInit {

  constructor(private userService: PortalUserService,
    private uiNotification : UiNotificationService,
    private customDialogService: CustomDialogService) { }

  linkedUsers$: Observable<PortalUserInfo[]>;
  @Input() referenceType: ReferenceType;
  @Input() referenceId: number


  @ViewChild("linkedUserSelectionDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;
  
  ngOnInit(): void {
   this.loadData();
  }

  loadData() {
    this.linkedUsers$ = this.userService.getLinkedUsers(this.referenceType, this.referenceId);
  }


  addUserLink() {

    const dialogSettings: CustomDialogSettings = {
      content: UserSelectDialogComponent,
      minHeight: '30vh',
      minWidth: '30vw',
      appendTo: this.containerRef,
      dialogInputs: {
        label: 'admin-center.user.userToLink',
      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {

          const selectedUserId = r['selectedUserId'];
          if(selectedUserId){
 
            this.userService.addUserLink(selectedUserId,this.referenceId, this.referenceType,'').subscribe(
              () => {
                this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
                this.loadData();
              });
          }
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }


  removeUserLink(userId: string){
    this.userService.removeUserLink(userId,this.referenceId, this.referenceType).subscribe(
      () => {
        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
        this.loadData();
      });
  }

}
